'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var styledComponents = require('./styled-components.js');

var DayElement = function (cdate, selectedDate, dayInCurrentMonth, dayComponent) {
    var visualizedDate = cdate ? cdate.format('D') : '';
    var dayElement = !dayInCurrentMonth ? (React__default.createElement(styledComponents.NotInMonthDayIcon, null,
        React__default.createElement("span", null,
            " ",
            visualizedDate,
            " "))) : (dayComponent);
    return React__default.createElement(styledComponents.StyledMainDay, null, dayElement);
};

module.exports = DayElement;
